<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <fieldset>
    <div formGroupName="acceptedCards">
      <div name="ccedit" id="ccedit"></div>
      <div class="form-group">
        <div class="col-md-12 accepted-cards">
          <ng-container *ngFor="let card of supportedCards | keyvalue">
            <label class="checkbox-inline">
              <input
                type="checkbox"
                name="acceptedCards"
                [formControlName]="card.key"
              />
              <img
                [src]="'./assets/img/' + card.value.image"
                [title]="card.value.title"
                [alt]="card.value.title"
                class="pl-1"
              />
            </label>
          </ng-container>
        </div>
        <div class="row" *ngIf="isEditable">
          <div class="col-md-8 offset-1 formValidationMessage">
            <div *ngIf="acceptedCardsFormControl.AMEX?.errors?.invalidAmexFee">
              AMEX fee must be added before card type can be selected
            </div>
          </div>
        </div>
        <div
          class="formValidationMessage"
          role="alert"
          *ngIf="
            (acceptedCards.invalid && acceptedCards.touched) ||
            acceptedCards.dirty
          "
        >
          <div class="text-danger" *ngIf="acceptedCards.errors?.required">
            At least one card must be selected.
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
